import { useContext } from 'react';
import { ToastContext } from '../../provider/PopupProvider';

export const usePopup = () => {
  return useContext(ToastContext);
};
